// @ts-strict-ignore

import { ConfigUI } from '@/components/Feature';
import {
  CardStatusButton,
  DeleteButton,
  DeleteMenu,
  DownloadButton,
  ShareButton,
  ToggleAskNeedlButton,
} from '@/components/Preview/common';
import { CardMetaHeader } from '@/components/SourceCards/common';
import type { ClickHandlerArgs } from '@/components/SourceCards/hooks/useFeedCard';
import { useIsFromNotebookSection } from '@/components/SourceCards/hooks/useIsFromNotebookSection';
import { CommentActionButton } from '@/features/Comment';
import { useResponsiveConstants } from '@/hooks/responsive/useResponsiveConstants';
import type { FeedItemType } from '@/types';

export const DISABLED_MESSAGE = 'Select a message to access this option';

export const PrimaryActions = ({
  result,
  handleShare,
  handleDelete,
  handleDeleteAll,
  handleDownload,
  selectedItemsCount,
  handleCommentClickOverRide,
  preview = false,
  disableComments = false,
  hideMetaHeader = false,
}: PrimaryActionsType) => {
  const { mobile } = useResponsiveConstants();
  const isNoteBookSection = useIsFromNotebookSection(result);
  if (mobile) {
    return null;
  }
  const showDeleteMenu =
    preview &&
    handleDeleteAll &&
    (selectedItemsCount > 1 || result.category === 'chats');

  const disableShare =
    preview &&
    typeof selectedItemsCount === 'number' &&
    selectedItemsCount !== 1;

  return (
    <>
      {hideMetaHeader ? null : <CardMetaHeader result={result} />}
      <ConfigUI feature='doc_mark_as_read'>
        {isNoteBookSection ? null : <CardStatusButton result={result} />}
      </ConfigUI>
      <ConfigUI feature='doc_share'>
        <ShareButton
          handleShare={handleShare}
          {...(disableShare && { tooltipLabel: DISABLED_MESSAGE })}
          disabled={disableShare}
        />
      </ConfigUI>
      <ConfigUI feature='comments'>
        <CommentActionButton
          deeplink={result?.deeplink}
          overrideClickHandler={handleCommentClickOverRide}
          disabled={disableComments}
        />
      </ConfigUI>
      <ConfigUI feature='doc_download'>
        <DownloadButton handleClick={handleDownload} />
      </ConfigUI>
      <ConfigUI feature='doc_delete'>
        {showDeleteMenu ? (
          <DeleteMenu
            selectedItemsCount={selectedItemsCount}
            handleDelete={handleDelete}
            handleDeleteAll={handleDeleteAll}
            group_name={result?.group_name}
          />
        ) : (
          <DeleteButton handleDelete={handleDelete} />
        )}
      </ConfigUI>
      <ToggleAskNeedlButton />
    </>
  );
};

type PrimaryActionsType = {
  result: FeedItemType;
  handleShare: (e: React.MouseEvent) => void;
  handleDelete?: (e: React.MouseEvent) => void;
  handleDeleteAll?: (e: React.MouseEvent) => void;
  handleDownload?: (e: React.MouseEvent) => void;
  selectedItemsCount?: number;
  handleCommentClickOverRide?: ({ comments }?: ClickHandlerArgs) => void;
  preview?: boolean;
  disableComments?: boolean;
  hideMetaHeader?: boolean;
};
